import { render } from "./Kanryo.vue?vue&type=template&id=1645e801&scoped=true"
import script from "./Kanryo.vue?vue&type=script&lang=js"
export * from "./Kanryo.vue?vue&type=script&lang=js"

import "./Kanryo.vue?vue&type=style&index=0&id=1645e801&scoped=true&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1645e801"]])

export default __exports__